import { Spin } from 'antd';
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { Environment } from 'relay-runtime';

import AlertEmptyProject from '../components/alertEmptyProject';
import useAfterLoader from '../hooks/useAfterLoader';
import { SmxGlobalFilterContext } from '../providers/globalFilterProvider';
import { useSharedUrlParams } from '../routing/useSharedUrlParams';
import { RootState } from '../store';
import { ItemTaskType, LoaderDataType, ScheduleItemType } from '../types';
import { TaskBoard } from './taskBoard';
import { TaskBoardColumnsType } from './taskBoardTypes';

interface TaskBoardWrapperProps {
    paddingBottom?: number;
    marginTop?: number;
    environment?: Environment;
}

export const TaskBoardWrapper: React.FC<TaskBoardWrapperProps> = ({ paddingBottom, marginTop }) => {
    const { filterProject } = useContext(SmxGlobalFilterContext);
    const columns = useSelector<RootState, TaskBoardColumnsType | null>((state) => state.taskBoard.columns);
    const dataScheduleItemFromServer = useSelector<RootState, LoaderDataType<ScheduleItemType>>(
        (state) => state.gantLoader.dataScheduleItemFromServer,
    );
    const dataTaskFromServer = useSelector<RootState, LoaderDataType<ItemTaskType>>(
        (state) => state.gantLoader.dataTaskFromServer,
    );

    useAfterLoader();
    useSharedUrlParams();

    const finishedLoading = Boolean(dataScheduleItemFromServer.connectionId && dataTaskFromServer.connectionId);

    return (
        <>
            {!!filterProject.length ? (
                <Spin tip={'Loading...'} spinning={!finishedLoading}>
                    <TaskBoard paddingBottom={paddingBottom} marginTop={marginTop} columns={columns ?? {}} />
                </Spin>
            ) : (
                <div style={{ width: '100%' }}>
                    <AlertEmptyProject />
                </div>
            )}
        </>
    );
};
